angular.module 'zc.projects'

.factory 'Chart', (chartConfig) ->

  factory =
    getChartConfig: (name, defaultVal={}) ->
      if !chartConfig[name]
        chart = $.extend true, defaultVal, chartConfig['base']
        chart.options =
          chart:
            type:
              name
        return chart
      return $.extend true, defaultVal, chartConfig[name]

    addSeries: (chartOptions, data) ->
      chartOptions.series.push(data)

  factory





// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects/services/chart_service.js.coffee